"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PunchPassFilterByEnum = exports.PunchPassOrderByEnum = exports.PunchPassSearchByEnum = void 0;
// TODO: Add the options when searching functionality is added
var PunchPassSearchByEnum;
(function (PunchPassSearchByEnum) {
    PunchPassSearchByEnum["USER_NAME"] = "user_name";
})(PunchPassSearchByEnum = exports.PunchPassSearchByEnum || (exports.PunchPassSearchByEnum = {}));
// TODO: Add the options when ordering functionality is added
var PunchPassOrderByEnum;
(function (PunchPassOrderByEnum) {
    PunchPassOrderByEnum["START_DATE"] = "start_date";
})(PunchPassOrderByEnum = exports.PunchPassOrderByEnum || (exports.PunchPassOrderByEnum = {}));
// TODO: Add the options when filtering functionality is added
var PunchPassFilterByEnum;
(function (PunchPassFilterByEnum) {
    PunchPassFilterByEnum["DATE_RANGE"] = "date_range";
})(PunchPassFilterByEnum = exports.PunchPassFilterByEnum || (exports.PunchPassFilterByEnum = {}));
//# sourceMappingURL=enums.js.map